import { useEffect, useState } from 'react';

/**
 * A ticking clock, safe to render on the server.
 *
 * Returns null until after mount. The routes are prerendered at build time, so
 * a clock that produced a real time during render would bake the build's clock
 * into the HTML and mismatch on hydration — which is exactly what discards the
 * prerendered DOM. Consumers render an em-dash placeholder for null, then the
 * real time appears on the first client tick.
 *
 * The terminal's status bar shows seconds; the marketing pages show HH:MM, so
 * they tick every 30s rather than re-rendering the page once a second.
 */
export function useNow(periodMs: number): Date | null {
  const [now, setNow] = useState<Date | null>(null);

  useEffect(() => {
    setNow(new Date());
    const id = setInterval(() => setNow(new Date()), periodMs);
    return () => clearInterval(id);
  }, [periodMs]);

  return now;
}
